import { ReactRenderer } from '@tiptap/react';
import { positionMenu, cleanupMenu } from './slashMenuUtils';
import SlashMenu from './SlashMenu';
import { SlashMenuProps, SlashSuggestionProps } from './slashCommand.types';
import { SuggestionKeyDownProps } from '@tiptap/suggestion';

export function createSlashCommandRender() {
  let component: ReactRenderer<HTMLUListElement, SlashMenuProps>;

  return {
    onStart: (props: SlashSuggestionProps) => {
      const { clientRect, editor } = props;

      component = new ReactRenderer<HTMLUListElement, SlashMenuProps>(
        SlashMenu,
        {
          props,
          editor
        }
      );

      if (!clientRect) return;

      document.body.appendChild(component.element);

      positionMenu(component, clientRect);
    },
    onUpdate: (props: SlashSuggestionProps) => {
      const { clientRect } = props;

      if (!component) return;

      component.updateProps(props);

      positionMenu(component, clientRect);
    },

    onKeyDown: (props: SuggestionKeyDownProps) => {
      if (!component) return;

      if (props.event.key === 'Escape') {
        cleanupMenu(component);

        return true;
      }

      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      return component.ref?.onKeyDown?.(props) ?? false;
    },
    onExit: () => {
      if (!component) return;

      cleanupMenu(component);
    }
  };
}
